import React, { useState, useCallback } from "react";
import {
  Dialog,
  Button,
  DialogTitle,
  DialogActions,
  Box,
  Typography,
  DialogContent,
  DialogContentText,
  Grid,
} from "@mui/material";
import Slide from "@mui/material/Slide";
import { logEventos } from "../../../services/services";
import { UrlApi } from "../../../services/apirest";
import ReferenciasLaboralesModalRechazo from "./ReferenciasLaboralesModalRechazo";

const ReferenciasLaboralesEval = ({
  id,
  id_candidato,
  mostrarAlertaTemporal,
  onClose,
  estado,
  open,
}) => {
  const [motivoRechazo, setMotivoRechazo] = useState("");
  const [openModalRechazo, setOpenModalRechazo] = useState(false);

  const handleSetMotivoRechazo = useCallback((value) => {
    setMotivoRechazo(value);
  }, []);

  const openModal = () => setOpenModalRechazo(true);
  const solicitud =
    estado === 1 ? { id, estado } : { id, estado, motivo: motivoRechazo };
  const interviewStatusUpdate = useCallback(
    async (solicitud) => {
      try {
        const response = await fetch(
          `${UrlApi}/SP_referencias/checkReferencias`,
          {
            method: "PUT",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(solicitud),
          }
        );

        if (!response.ok) {
          mostrarAlertaTemporal(
            "Hubo un error al actualizar el estado",
            "error"
          );
        } else {
          mostrarAlertaTemporal("Estado actualizado correctamente", "success");
        }
      } catch (error) {
        console.error("Error en la solicitud", error);
        mostrarAlertaTemporal("Server busy, Try again later", "error");
      }

      try {
        const response = await fetch(
          `${UrlApi}/SP_candidatos/verificarAptitud/${id_candidato}`,
          {
            method: "PUT",
            headers: { "Content-Type": "application/json" },
          }
        );

        if (!response.ok) {
          mostrarAlertaTemporal("Error al actualizar candidato", "error");
        } else {
          mostrarAlertaTemporal("Estado del candidato actualizado", "success");
        }
      } catch (error) {
        console.error("Error en la solicitud", error);
        mostrarAlertaTemporal("Server busy, Try again later", "error");
      }

      logEventos(
        "Aprobando/Desaprobando Referencias laborales",
        "Referencias laborales",
        "Cambiando el estado de la Referencia laboral de los candidatos",
        localStorage.getItem("user")
      );

      onClose();
    },
    [mostrarAlertaTemporal, onClose, id_candidato]
  );

  return (
    <>
      {openModalRechazo && (
        <ReferenciasLaboralesModalRechazo
          setMotivo={handleSetMotivoRechazo}
          motivo={motivoRechazo}
          onClose={() => setOpenModalRechazo(false)}
          open={openModalRechazo}
          handleSubmit={() => interviewStatusUpdate(solicitud)}
          mostrarAlertaTemporal={mostrarAlertaTemporal}
        />
      )}
      <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
        <Box justifyContent="center" backgroundColor="#1F618D">
          <DialogTitle>
            <Box component="div">
              <Typography
                variant="h6"
                align="center"
                color="#ffffff"
                sx={{ fontWeight: "bold" }}
              >
                {estado === 1
                  ? `Aprobar la referencia`
                  : `Desaprobar la referencia`}
              </Typography>
            </Box>
          </DialogTitle>
        </Box>
        <DialogContent>
          <DialogContentText textAlign={"center"}>
            {estado === 1
              ? `¿Esta seguro que quiere aprobar la referencia laboral?`
              : `¿Esta seguro que quiere desaprobar la referencia laboral?`}
          </DialogContentText>
        </DialogContent>

        <DialogActions>
          <Grid
            container
            direction="row"
            justifyContent="space-around"
            alignItems="center"
          >
            <Button
              variant="contained"
              onClick={onClose}
              style={{ backgroundColor: "#d32f2f", color: "#ffffff" }}
            >
              Volver
            </Button>
            <Button
              style={{ color: "#ffffff" }}
              type="submit"
              onClick={
                estado === 1
                  ? () => interviewStatusUpdate(solicitud)
                  : openModal
              }
              variant="contained"
              color="primary"
            >
              Confirmar
            </Button>
          </Grid>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default ReferenciasLaboralesEval;
